import { createI18n } from 'vue-i18n'
import us from './_us'
import kr from './_kr'
export default createI18n({
  legacy:false,
  locale: 'kr',
  fallbackLocale: 'us',
  messages: {
    us: us,
    kr: kr
  }
})
